/**
 * @file wms-registry-filters.ts
 * @description Общие варианты фильтров реестров склада (phase19.31, зона
 * «Склад»): выбор склада одинаков в приёмках, перемещениях, списаниях и
 * резервах — одна функция вместо четырёх копий списка «Все склады + склады».
 */

/** Минимум полей склада для фильтра. */
interface WarehouseRef {
  id: string;
  name: string;
}

/** «Все склады» + склады магазина; пустое значение — без отбора. */
export function warehouseOptions(warehouses: readonly WarehouseRef[], allLabel = "Все склады") {
  return [{ value: "", label: allLabel }, ...warehouses.map((w) => ({ value: w.id, label: w.name }))];
}
